import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const UseOfProceedsModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // form fields
    useOfProceeds, onUseOfProceedsChange, useOfProceedsError, setUseOfProceedsError,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Update amounts'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='uop' maxLength={12}
      label='Use of proceeds amount'
      value={useOfProceeds} onChange={onUseOfProceedsChange}
      error={useOfProceedsError} setError={setUseOfProceedsError}
      autoFocus={true}
    />
  </ModalFormUI>

export default UseOfProceedsModalUI
